var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMintSelectedDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u62CD\u5356") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-6\\u5907\\u4EFD-4",
    transform: "translate(-359.000000, -25.000000)",
    fill: "#F9F9F9",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-15",
    transform: "translate(250.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-8\\u5907\\u4EFD",
    transform: "translate(100.000000, 23.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u62CD\\u5356",
    transform: "translate(9.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    opacity: 0,
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.4,24.96 L25.6,24.96 C27.2,24.96 28,25.76 28,27.36 L28,27.36 C28,28.96 27.2,29.76 25.6,29.76 L6.4,29.76 C4.8,29.76 4,28.96 4,27.36 L4,27.36 C4,25.76 4.8,24.96 6.4,24.96 Z",
    id: "\\u8DEF\\u5F84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.94368,5.86448 C24.56848,6.48928 24.56848,7.5024 23.94368,8.1272 L19.74656,12.32416 L26.61856,19.19632 C27.58128,20.15888 27.58128,21.71952 26.61856,22.68224 C25.656,23.6448 24.09536,23.6448 23.1328,22.68224 L16.2608,15.81024 L12.26304,19.80784 C11.63824,20.4328 10.62512,20.4328 10.00032,19.80784 L5.29152,15.09904 C4.66656,14.47408 4.66656,13.46096 5.29152,12.83616 L16.972,1.15552 C17.5968,0.53072 18.60992,0.53072 19.23472,1.15552 L23.94368,5.86448 Z",
    id: "\\u8DEF\\u5F84"
  }))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMintSelectedDark);
export default __webpack_public_path__ + "static/media/mint-selected-dark.95d04960cfc4492e556353f810b0b416.svg";
export { ForwardRef as ReactComponent };